

















































































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import Menu from '@/components/common/Menu.vue';
import VpnUserDownload from '@/components/vpn/VpnUserDownload.vue';
import { vpnService } from '@/services/VpnService';
import { mapState } from 'vuex';

@Component({
  components: {
    Header,
    InfoBar,
    Menu,
    VpnUserDownload,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class Vpn extends Vue {
  workspaceId = 0;
  regionId = 0;
  isModalShown = false;
  isAddingVPNClientActive = false;
  users: any = {};
  vpnUserId = '';
  email = '';
  userName = '';
  emailErrors: any = [];
  userNameErrors: any = [];
  addingFirstUser = true;
  isRemoveModalShown = false;
  deleteVpnUserId = '';
  deleteVpnUserName = '';
  isLoading = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.getVpnUsers();
  }
  addFirstUser() {
    this.addingFirstUser = false;
    this.isAddingVPNClientActive = true;
  }
  downloadClick(userId: string) {
    this.vpnUserId = userId;
    this.isModalShown = true;
  }
  addNewVpnClient() {
    this.emailErrors = [];
    this.userNameErrors = [];
    if (!this.email) {
      this.emailErrors.push(this.$t('scripts.emailRequired'));
    }
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        this.email
      ) &&
      this.email
    ) {
      this.emailErrors.push(this.$t('scripts.emailFormatIsWrong'));
    }
    if (!this.userName) {
      this.userNameErrors.push(this.$t('scripts.usernameIsRequired'));
    }
    if (this.userName.indexOf(' ') !== -1 && this.userName) {
      this.userNameErrors.push(this.$t('scripts.usernameFormatIsWrong'));
    }
    if (this.emailErrors.length > 0 || this.userNameErrors.length > 0) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    vpnService
      .createVpnUser(this.workspaceId, this.regionId, this.userName, this.email)
      .then(() => {
        this.isLoading = false;
        this.getVpnUsers();
        this.email = '';
        this.userName = '';
        this.isAddingVPNClientActive = false;
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data.data && data.data.error && data.data.error.username[0].error === 'taken') {
            this.userNameErrors.push(this.$t('scripts.usernameIsTaken'));
          }
          if (data.data && data.data.error && data.data.error.username[0].error === 'invalid') {
            this.userNameErrors.push(this.$t('scripts.usernameFormatIsWrong'));
          }
        }
      });
  }
  getVpnUsers() {
    vpnService.getVpnUsers(this.workspaceId, this.regionId).then((data: any) => {
      this.users = data;
    });
  }
  openDeleteVpnUserModal(userUuid: any, userName: any) {
    this.deleteVpnUserId = userUuid;
    this.deleteVpnUserName = userName;
    this.isRemoveModalShown = true;
  }
  onCloseRemoveModal() {
    this.isRemoveModalShown = false;
  }
  deleteVpnUser(userId: any) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    vpnService
      .deleteVpnUser(this.workspaceId, this.regionId, userId)
      .then(() => {
        this.isLoading = false;
        this.isRemoveModalShown = false;
        this.getVpnUsers();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
